import styled from "styled-components";

export const PreviewBox = styled.div`
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px; */
  padding-bottom: 10px;
  /* border-bottom: 1px solid #D1D0CB; */
`;
export const AdPreview = styled.div`
  /* h2 {
    font-size: 18px;
    line-height: 150.5%;
    font-family: "latobold";
    padding: 20px 0;
    border-bottom: 1px solid #D1D0CB;
    margin-bottom: 30px;
  } */
`;
export const ImagePreviewBox = styled.div`
  padding-top: 58%;
  position: relative;
  overflow: hidden;
  border-radius: 2px;
  .full-view-image {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    border-radius: 15px;
    width: 100%;
    cursor: pointer;
  }
  .preview-image {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 149px;
  }
`;
export const GallerySection = styled.div`
  max-width: 398px;
  background: #ffffff;
  box-shadow: 2px 4px 5px 2px rgba(0, 0, 0, 0.02);
  padding: 0px;
  margin: 10px;
`;

export const GalleryHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #d1d0cb;
  h3 {
    font-size: 18px;
    line-height: 150.5%;
    font-family: "latobold";
  }
`;
export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  input {
    background: #ffffff;
    border: 0.5px solid #cdcfd0;
    border-radius: 25px;
    padding: 0 25px 0 20px;
    min-height: 28px;
    width: 220px;
  }
  img {
    position: absolute;
    right: 8px;
    width: 12px;
  }
`;
export const CenterSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 29px;
  column-gap: 0px;
  > div {
    flex: 1;
  }
`;
export const Status = styled.div`
  padding-bottom: 10px;
  border-bottom: 1px solid #d1d0cb;

  .row-div {
    gap:5px;
    display: flex;
    align-items: center;
    padding-top: 10px;
    .label {
      font-size: 13px;
      line-height: 16px;
      min-width: 45px;
    }
    .btn-wrapper {
      display: flex;
      align-items: center;
      gap: 11px;
      margin-right: 17px;
      button {
        font-size: 13px;
        line-height: 16px;
        width: 69px;
        height: 30px;
        border: 0.5px solid #cdcfd0;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        &.active {
          background-color: #bc9b6a;
          color: #fff;
          border: transparent;
        }
      }
    }
    .MuiOutlinedInput-notchedOutline {
      border: 0.5px solid #cdcfd0;
      border-radius: 6px;
    }
    .MuiSelect-select {
      min-height: 30px;
      padding: 0 32px 0 13px;
      display: flex;
      align-items: center;
      font-size: 13px;
      font-family: "latoregular";
    }
    .MuiFormControl-root {
      width: 100%;
      margin: 0;
    }
  }
`;

export const DescriptionSection = styled.div`
  padding: 30px;
  display: flex;
  align-items: flex-start;
  gap: 28px;
  box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.05);
  .editable {
    background: #ffffff;
    border: 0.5px solid #cdcfd0;
    border-radius: 6px;
    min-height: 30px;
    width: 100%;
    padding: 0 5px;
    cursor: copy;
    align-items: center;
    display: inline-flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .disable {
    opacity: 0.6;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .circle-btn {
    min-width: 118px;
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    :disabled {
      opacity: 0.5;
    }
}

  .main-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(252px, 1fr));
    gap: 28px;
    flex: 1;
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 40px;
    position: relative;
    .error-msg {
      position: absolute;
      bottom: -11px;
      right: 0;
      color: red;
      font-size: 12px;
    }
    span {
      font-size: 13px;
    }
    .MuiBox-root {
      max-width: 100%;
      width: 100%;
      height: auto;
    }
  }
  p {
    font-size: 13px;
    line-height: 16px;
    white-space: nowrap;
    min-width: 84px;
  }
  input {
    background: #ffffff;
    border: 0.5px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    width: 100%;
    padding: 0 5px;
  }
  .date {
    font-size: 13px;
    line-height: 16px;
    color: #fff;
  }
  @media (max-width: 1600px) {
    gap: 20px 2.5vw;
  }
  @media (max-width: 1372px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const GalleryDetails = styled.div`
  .MuiFormGroup-root {
    flex-direction: row;
    justify-content: space-between;
    padding: 11px 0;
  }
`;

export const GalleryWrapper = styled.div`
  max-height: 29vh;
  overflow: auto;
  .data-wrapper {
    display: flex;
    align-items: center;
    gap: 28px;
    margin: 20px 0;
    cursor: pointer;
    p {
      font-size: 13px;
      line-height: 150.5%;
      word-break: break-word;
    }
    .image-wrapper {
      min-width: 86px;
      max-width: 86px;
      min-height: 50px;
      max-height: 50px;
      border-radius: 2px;
      overflow: hidden;
      img {
        max-width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }
  }
`;

export const MainDataWrapper = styled.div`
  padding: 23px 0;
  .MuiOutlinedInput-notchedOutline {
    border: 0.5px solid #cdcfd0;
    border-radius: 6px;
  }
  .MuiSelect-select {
    padding: 0 32px 0 13px;
    display: flex;
    align-items: center;
    font-size: 18px;
    min-height: 30px !important;
    font-family: "latobold";
  }
  .MuiFormControl-root {
    margin: 0;
  }
`;

export const ArchivedCampaignContainerModal = styled.div`
  width: 100%;
  .header {
    min-height: 56px;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 22px;
    background-color: var(--filter-bar-bg);
    position: relative;
    h3 {
      font-weight: 500;
      font-size: 22px;
      line-height: 150.5%;
      color: var(--theme-text);
    }
    button {
      background: transparent;
      border: none;
      position: absolute;
      right: -17px;
      top: -13px;
    }
  }
  .modal-body {
    display: block;
    background: var(--theme-text);
    border-radius: 0px 0px 10px 10px;
    padding: 30px;

    .input-wrapper {
      display: block;
      align-items: center;
      gap: 30px;
      p.label {
      display: block;
        font-size: 13px;
        line-height: 16px;
        white-space: nowrap;
      }
      .MuiInputBase-root {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
      }
      .MuiFormLabel-root {
        display: none;
      }
      .MuiSelect-select {
        padding: 7.5px 14px;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 13px;
      }
      legend {
        display: none;
      }
      .MuiOutlinedInput-notchedOutline {
        display: none;
      }
    }
    .action-btn {
      margin-top: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 18px;
      button {
        padding: 5px 20px;
        font-size: 13px;
        line-height: 150.5%;
        border: 1px solid #636f7c;
        border-radius: 100px;
      }
    }
  }
`;

export const SuccessModalContainer = styled.div`
  padding: 63px 10px 45px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: #fff;
  border-radius: 10px;
  .close-icon {
    position: absolute;
    right: -13px;
    top: -12px;
  }
`;